<template>
  <ul class="progress-bar">
    <li
      class="progress-bar-item is-on"
      v-for="(n, index) of onCount"
      :key="`on-${index}`"
    ></li>
    <li
      class="progress-bar-item is-off"
      v-for="(n, index) of offCount"
      :key="`off-${index}`"
    ></li>
  </ul>
</template>

<script>
export default {
  props: {
    onCount: {
      type: Number,
      required: true
    },
    offCount: {
      type: Number,
      required: true
    }
  }
}
</script>